var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.98 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Compliance_Activities-icon",
    "data-name": "Compliance Activities-icon"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.31,0H6.67A6.68,6.68,0,0,0,0,6.68V33.33A6.67,6.67,0,0,0,6.67,40H33.31A6.66,6.66,0,0,0,40,33.33V6.68A6.67,6.67,0,0,0,33.31,0Zm5.07,33.33a5.07,5.07,0,0,1-5.07,5.07H6.67A5.08,5.08,0,0,1,1.6,33.33V6.68A5.09,5.09,0,0,1,6.67,1.6H33.31a5.08,5.08,0,0,1,5.07,5.08Z",
    fill: "#0e265e"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.13,14.51V33a.23.23,0,0,1-.23.23H10.23A.23.23,0,0,1,10,33V7.5a.23.23,0,0,1,.23-.23H25.5L25.67,7l.39-.71H10.23A1.25,1.25,0,0,0,9,7.5V33a1.25,1.25,0,0,0,1.25,1.25H28.9A1.25,1.25,0,0,0,30.15,33V12.69Zm0-5.08v.38l.16-.29ZM27.59,6.25v0l0,0Z",
    fill: "#678bc7"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22.58 12.47 21.87 13.74 13.08 13.74 13.08 12.47 22.58 12.47",
    fill: "#202a5c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.74 19.34 18.03 20.61 13.08 20.61 13.08 19.34 18.74 19.34",
    fill: "#202a5c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "25 19.34 24.29 20.61 24.28 20.61 24.99 19.34 25 19.34",
    fill: "#202a5c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26.05 20.01 26.05 20.61 25.71 20.61 26.05 20.01",
    fill: "#202a5c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.49 26.21 15.31 27.48 13.08 27.48 13.08 26.21 15.49 26.21",
    fill: "#202a5c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.15 26.21 20.62 27.14 21.14 26.21 21.15 26.21",
    fill: "#202a5c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26.05 26.21 26.05 27.48 21.86 27.48 22.57 26.21 26.05 26.21",
    fill: "#202a5c"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "16.92 25.15 16.89 25.2 16.9 25.16 16.92 25.15",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.29 9.52 29.13 9.81 29.13 9.43 29.29 9.52",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.21 10.03 30.21 10.04 30.15 10.14 30.15 10 30.21 10.03",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.69,25.54v0Zm4.45.67-.52.93.53-.93,3.13-5.6ZM25,19.34l-.71,1.27h0L25,19.34,29.13,12ZM31.07,7.09a2.05,2.05,0,0,1,.1.65,2.11,2.11,0,0,1-.27,1l-.18.33-.51.93h0l.48-.87,0-.06.18-.33a2.14,2.14,0,0,0,.27-1A1.87,1.87,0,0,0,31.07,7.09Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.15,10v.14l.06-.1h0Zm-9,16.21-.52.93.53-.93,3.13-5.6ZM25,19.34l-.71,1.27h0L25,19.34,29.13,12ZM30.72,9.1l-.51.93.49-.86,0-.06Z",
    fill: "#0e265e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.15 10 30.15 10.15 29.13 11.96 29.13 11.97 24.99 19.34 24.28 20.61 21.14 26.21 20.62 27.14 20.44 27.48 20.38 27.58 20.37 27.6 20.24 27.53 20.15 27.48 17.86 26.21 16.83 25.64 16.69 25.56 16.7 25.54 16.89 25.2 16.92 25.15 19.46 20.61 20.17 19.34 23.31 13.74 24.02 12.47 26.93 7.27 26.54 7.99 27.46 8.5 25.24 12.47 24.52 13.74 21.39 19.34 20.67 20.61 18.13 25.15 19.96 26.16 23.07 20.61 23.78 19.34 29.13 9.81 29.29 9.52 30.15 10",
    fill: "#202a5c"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "16.7 25.54 16.69 25.56 16.69 25.54 16.7 25.54",
    fill: "#678bc7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.69,25.54v0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.37,27.6l-3.55,2.9a.5.5,0,0,1-.3.11.5.5,0,0,1-.26-.08l-.07-.06a.46.46,0,0,1-.15-.41l.37-2.58.18-1.27.1-.65.14.08,1,.57,2.29,1.27.09.05Z",
    fill: "#678bc7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.07,7.09a2.05,2.05,0,0,1,.1.65,2.11,2.11,0,0,1-.27,1l-.18.33-.51.93h0l.48-.87,0-.06.18-.33a2.14,2.14,0,0,0,.27-1A1.87,1.87,0,0,0,31.07,7.09Z",
    fill: "#678bc7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.17,7.74a2.11,2.11,0,0,1-.27,1l-.18.33-.51.93-.06,0-.86-.48-.16-.09L27.46,8.5,26.54,8l.39-.72.12-.21.18-.33a1.43,1.43,0,0,1,.16-.24,2,2,0,0,1,.19-.22l0,0a2.13,2.13,0,0,1,2.5-.34,2.09,2.09,0,0,1,.89,1,1.8,1.8,0,0,1,.08.21A2.05,2.05,0,0,1,31.17,7.74Z",
    fill: "#678bc7"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAct);
export default __webpack_public_path__ + "static/media/act.4b2877326b7023fa5432dc85e3d4a220.svg";
export { ForwardRef as ReactComponent };